import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ability, createMongoAbility } from '@casl/ability';
import { TranslatePipe } from '@ngx-translate/core';
import { PermissionsService } from './permissions.service';
import { RolesService } from './roles.service';
import { ConfigModule } from '@wilson/config';
import { FeaturePurePipe } from './pipes/feature-pure.pipe';
import { FeatureSignalPipe } from './pipes/feature-signal.pipe';
import { RolesPipe } from './pipes/roles.pipe';

@NgModule({
  imports: [CommonModule, ConfigModule, TranslatePipe, FeatureSignalPipe],
  providers: [
    RolesService,
    PermissionsService,
    { provide: Ability, useValue: createMongoAbility() },
    FeaturePurePipe,
    FeatureSignalPipe,
    RolesPipe,
  ],
  exports: [FeaturePurePipe, FeatureSignalPipe, RolesPipe],
  declarations: [FeaturePurePipe, RolesPipe],
})
export class AuthorizationModule {}
